import { Translation } from './translation';

export const fr_fr: Partial<Translation> = {
  common: {
    currency: {
      short: 'EUR',
      price: `{price} €`,
      pricePerMonth: `{price} € / mois`,
      pricePerSquareMeter: `{price} €/m<sup>2</sup>`,
    },
  },
  filters: {
    search: {
      label: 'Ville, lieu, code postal, référence du bien, ...',
    },
    livingSpace: {
      label: 'Surface habitable',
    },
  },
  regionSearch: {
    state: 'Région',
    county: 'Département',
    suburb: 'Arrondissement',
  },
  searchSubscription: {
    save: 'Créer une alerte e-mail',
    overlay: {
      title: 'Alerte e-mail',
    },
    stepper_title: {
      desktop: {
        step3: "Finaliser l'alerte e-mail",
      },
      mobile: {
        step2: "Finaliser l'alerte e-mail",
      },
    },
    search: {
      label: 'Ville, lieu, code postal, ...',
    },
  },
  realEstateObject: {
    topOffer: 'Exclusivité',
    reserved: 'Sous offre',
  },
};
